import API from "../API/newIndex";
export let clientData;
export let installedExtentionData;
let business_name = localStorage.getItem("business_name");
export const GetClient = async () => {
  if (business_name) {
    await API({ url: "/admin/client/getClient", method: "get" })
      .then((res) => {
        if (res?.data) {
          const result = res?.data;
          clientData = result?.data;
        }
      })
      .catch((error) => {
        if (error?.response?.status === 881) {
          localStorage.removeItem("token");
          localStorage.removeItem("business_name");
        }
      });
  }
};

export const GetInstalledExtentionData = async () => {
  await API({ url: "/admin/extension/GetInstalledExtensions", method: "get" })
    .then((res) => {
      if (res?.data) {
        const result = res?.data;
        installedExtentionData = result?.data;
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
